<template>
    <v-card :loading="loading">
        <v-card-title class="grey lighten-2 text-h5 font-weight-bold">
            {{ $vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.intrusionssummary') }}
            <v-spacer />
            <v-btn icon color="black" outlined @click="refresh">
                <v-icon>mdi-refresh</v-icon>
            </v-btn>
        </v-card-title>
        <v-skeleton-loader
            type="list-item@8"
            v-if="loading"
        ></v-skeleton-loader>
        <v-container v-else fluid>
            <v-row justify="center">
                <v-col>
                    <v-card outlined min-height="176">
                        <v-card-title class="text-h5 text-center font-weight-black">{{ current_month }}</v-card-title>
                        <v-card-title class="text-h5 py-1 justify-center font-weight-black">
                            {{ count_current_month }} {{ $vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.intrusion') }}{{ count_current_month > 1 ? "s" : "" }}
                        </v-card-title>
                        <v-container>
                            <v-divider></v-divider>
                        </v-container>
                        <v-card-subtitle
                            class="ma-0 pt-0 text-center font-weight-black"
                            :class="{ 'red--text' : current_past_diff > 0 && count_current_month > count_past_month,
                                        'green--text' : current_past_diff > 0 && count_current_month < count_past_month }"
                        >
                            {{ current_past_diff != 0 ? count_current_month > count_past_month ? "+" : "-" : "" }}{{ current_past_diff != 0 ? `${current_past_diff} ${$vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.compared')}` : $vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.equal') }} {{ $vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.tolastmonth') }}
                        </v-card-subtitle>
                    </v-card>
                    <v-row v-if="count_total !== 0" align="center" justify="center" no-gutters>
                        <v-col cols="1">
                            <v-icon small>mdi-clock-outline</v-icon>
                        </v-col>
                        <v-col cols="auto">
                            <v-tooltip bottom open-delay="500">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-card-subtitle v-if="$vuetify.lang.current=='en'" class="text-caption" v-bind="attrs" v-on="on">
                                            Last intrusion occured {{ delta_last_intrusion == 0 ? "today" : delta_last_intrusion + " day" + ( Math.abs(delta_last_intrusion) > 1 ? "s" : "" ) + " ago" }}
                                    </v-card-subtitle>
                                    <v-card-subtitle v-else class="text-caption" v-bind="attrs" v-on="on">
                                            Dernière intrusion déclenchée {{ delta_last_intrusion == 0 ? "Aujourd'hui" : "Il y a " + delta_last_intrusion + " jour" + ( Math.abs(delta_last_intrusion) > 1 ? "s" : "" )}}
                                    </v-card-subtitle>
                                </template>
                                <span>{{ last_intrusion_datetime }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col :cols="($vuetify.breakpoint.width < 540) || (($vuetify.breakpoint.width >= 1264) && ($vuetify.breakpoint.width < 1743)) ? '12' : ''">
                    <v-alert
                        dense
                        v-ripple
                        :outlined="count_active == 0"
                        :class="count_active>0 ? 'pointer-cursor' : 'default-cursor'"
                        class="text-center"
                        @click="redirectToIntrusions('isactive', true)"
                        :type="count_active > 0 ? 'error' : 'success'"
                        :color="count_active > 0 ? 'red' : ''"
                    >
                        <span class="font-weight-black text-h4">{{ count_active }}</span>
                        <br>
                        {{$vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.intrusion')}}{{ count_active > 1 ? "s" : ""}} {{$vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.currentlyactive')}}
                    </v-alert>
                    <v-alert
                        dense
                        v-ripple
                        :outlined="count_not_consulted == 0"
                        :class="count_not_consulted>0 ? 'pointer-cursor' : 'default-cursor'"
                        class="text-center"
                        @click="redirectToIntrusions('isconsulted', false)"
                        :type="count_not_consulted > 0 ? 'error' : 'success'"
                        :color="count_not_consulted > 0 ? 'orange' : ''"
                    >
                        <span class="font-weight-black text-h4">{{ count_not_consulted }}</span>
                        <br>
                        {{ $vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.intrusion') }}{{ count_not_consulted > 1 ? "s" : "" }} {{ $vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.notconsulted') }}
                    </v-alert>
                </v-col>
            </v-row>
            <v-row align="center" justify="center" no-gutters class="mt-lg-8">
                <v-col cols="auto">
                    <v-icon dense>mdi-card-account-details-outline</v-icon>
                </v-col>
                <v-col cols="auto">
                    <v-card-title>
                        {{ $vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.notificationsaresentto') }} {{ count_contact }} {{ count_contact > 1 ? $vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.people') : $vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.person') }}
                    </v-card-title>
                </v-col>
                <v-col cols="auto">
                    <v-btn elevation="0" :class="!isAdministration ? '' : 'gradient-wintech'" @click="redirectToUsers()" :disabled="!isAdministration">
                        <v-icon left>mdi-pencil</v-icon>
                        {{ $vuetify.lang.t('$vuetify.dashboard.intrusionsRecapCard.manage') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
    name: "IntrusionsRecapCard",
    data() {
        return {
            loading: true,
            count_total: 0,
            count_active: 0,
            count_not_consulted: 0,
            count_past_month: 0,
            count_current_month: 0,
            last_intrusion_datetime: undefined,
            count_contact: 0,
        }
    },
    computed: {
        current_month: function() {
            let month;
            if(this.$vuetify.lang.current=='en' ){
                month = new Date().toLocaleDateString("en-US", {month: 'long'})
            }
            else {
                month = new Date().toLocaleDateString("fr-FR", {month: 'long'})
            }
            return month.charAt(0).toUpperCase() + month.slice(1);            
        },
        current_past_diff: function() {
            return Math.abs(this.count_past_month - this.count_current_month)
        },
        delta_last_intrusion: function() {
            let d = new Date()
            return Math.round((d.getTime() - this.last_intrusion_datetime.getTime()) / (1000 * 3600 * 24))
        },
        ...mapGetters({ isLoggedIn: "isAuthenticated", user: "StateUser" }),
        isAdministration() {
            return this.user.role === "ADMINISTRATION"
        },
    },
    mounted() {
        this.$root.$on('refreshDash', () => {
            this.refresh()
        }),
        this.refresh()
    },
    methods: {
        async refresh() {
            this.loading = true;
            try {
                const res = await axios.get('dashboard/intrusionInfos/'+this.user.orga);
                if (res.status == 200) {
                    this.count_total = res.data.count_total_intrusion;
                    this.count_active = res.data.count_active_intrusion;
                    this.count_not_consulted = res.data.count_not_consulted_intrusion;
                    this.count_past_month = res.data.count_past_month_intrusion;
                    this.count_current_month = res.data.count_current_month_intrusion;
                    this.last_intrusion_datetime = new Date(res.data.last_intrusion_datetime);
                    this.count_contact = res.data.count_contact_intrusion;
                }
            } catch(err) {
                console.error(err);
            }
            setTimeout(() => {
                this.loading = false;
            }, 300)
        },
        redirectToIntrusions: function(filter, value) {
            let query = {};
            query[filter] = value;
            this.$router.push({ path: "intrusions", query: query });
        },
        redirectToUsers: function() {
            this.$router.push({ path: "Users" });
        },
    }
}
</script>
<style scoped>
    .pointer-cursor {
        cursor: pointer;
    }
    .default-cursor {
        cursor: default;
    }
</style>
